import './wins-marquee.scss';

import { useAppSelector } from '@/app/store/hooks';
import { selectFeedItems, selectFeedLoading } from '@/entities/activity';
import { getWinTier } from '@/shared/lib/game/getWinTier';
import { PlayerAvatar } from '@/shared/ui/PlayerAvatar';

function formatTON(amount: number): string {
  return amount >= 1000 ? `${(amount / 1000).toFixed(1)}K` : amount.toFixed(2);
}

export function WinsMarquee() {
  const items = useAppSelector(selectFeedItems);
  const loading = useAppSelector(selectFeedLoading);

  if (loading || items.length === 0) {
    return <div className="wins-marquee wins-marquee--empty" aria-hidden="true" />;
  }

  const wins = items.slice(0, 12);

  return (
    <div className="wins-marquee" aria-hidden="true">
      <div className="wins-marquee__track">
        {[...wins, ...wins].map((item, i) => (
          <div key={`${item.winner_id}-${item.finished_at}-${i}`} className="wins-marquee__item">
            <PlayerAvatar id={item.winner_id} avatar={item.winner_avatar} size={28} />
            <span className="wins-marquee__name">{item.winner_username}</span>
            <span
              className={`wins-marquee__amount wins-marquee__amount--${getWinTier(item.payout)}`}>
              +{formatTON(item.payout)} TON
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
